export default __webpack_public_path__ + "static/media/faq-product-table1.d34e118e.webp";